import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './TestCase.scss';
import digitalizzazioneCustomModalSuccess
  from "../../../CaseGenerator/custom-success-modal/digitalizzazioneCustomModalSuccess";

const TestCase = () => {
  return (
    <div className="TestCase" data-testid="TestCase">
      <CaseGenerator type={CaseForms.Test}
                     signDigital={true} // this is mandatory if you want custom success modal
                     successModalCustom={
                       (props) => digitalizzazioneCustomModalSuccess(props)
                     }

      initialValues={{signDigital: true}}/>
    </div>
  )
};

export default TestCase;
